// If we do not keeps enums separate but instead import them from
// node files we are not able to use them in the app without the build failing

export { RoleType as UserRole } from 'api-user-client'

export enum SupportedLocaleCode {
  deDE = 'de-DE',
  enAU = 'en-AU',
  enDE = 'en-DE',
  enID = 'en-ID',
  enIN = 'en-IN',
  enKR = 'en-KR',
  enMY = 'en-MY',
  enNZ = 'en-NZ',
  enPH = 'en-PH',
  enSG = 'en-SG',
  enTH = 'en-TH',
  enTW = 'en-TW',
  enVN = 'en-VN',
  koKR = 'ko-KR',
  // idID = 'id-ID',
  thTH = 'th-TH',
  viVN = 'vi-VN',
  zhTW = 'zh-TW',
}

export enum SupportedCountry {
  Australia = 'AU',
  Germany = 'DE',
  India = 'IN',
  Indonesia = 'ID',
  Korea = 'KR',
  Malaysia = 'MY',
  NewZealand = 'NZ',
  Philippines = 'PH',
  Singapore = 'SG',
  Taiwan = 'TW',
  Thailand = 'TH',
  Vietnam = 'VN',
}
export type KeyOfSupportedCountry = keyof typeof SupportedCountry
export type ValuesOfSupportedCountry = typeof SupportedCountry[KeyOfSupportedCountry]

export enum SupportedSalesOrganisation {
  Australia = 'AU01',
  Germany = 'DE01',
  Hongkong = 'HK01',
  India = 'IN01',
  Indonesia = 'ID01',
  Korea = 'KR01',
  Malaysia = 'MY01',
  NewZealand = 'NZ01',
  Philippines = 'PH01',
  Singapore = 'SG01',
  Taiwan = 'TW01',
  ThailandBIT = 'TH11',
  ThailandTD = 'TH21',
  VietnamBrenntag = 'VN01',
  VietnamNamGiang = 'ZV01',
}

export enum SupportedSalesOrganisationPayOnline {
  Australia = 'AU01',
  NewZealand = 'NZ01',
  Singapore = 'SG01',
}

export enum SupportedRegion {
  ALL = 'ALL',
  APAC = 'APAC',
  EMEA = 'EMEA',
}

export enum SupportedLanguage {
  ChineseChina = 'zh-CN',
  ChineseTaiwan = 'zh-TW',
  English = 'en',
  German = 'de',
  Indonesian = 'id',
  Korean = 'ko',
  Thai = 'th',
  Vietnamese = 'vi',
}

export enum NavigationBlockModalType {
  OrderEdit = 'OrderEdit',
  UserEdit = 'UserEdit',
}

export enum Page {
  AccessRestricted = 'AccessRestricted',
  Cart = 'Cart',
  Home = 'Home',
  InvoiceDetails = 'InvoiceDetails',
  Invoices = 'InvoiceList',
  Login = 'Login',
  NOT_FOUND = '@@redux-first-router/NOT_FOUND' /* Special value for Redux-First-Router -- Do not change */,
  NotFound = 'NotFound',
  OrderConfirmation = 'OrderConfirmation',
  OrderDetails = 'OrderDetails',
  Orders = 'OrderList',
  PaymentInvoice = 'PaymentInvoice',
  PaymentInvoiceRedirect = 'PaymentInvoiceRedirect',
  ProductDetails = 'ProductDetails',
  Products = 'ProductList',
  Profile = 'Profile',
  QuoteDetails = 'QuoteDetails',
  Quotes = 'QuoteList',
  TermsAndConditions = 'TermsAndConditions',
  UserEdit = 'UserEdit',
  Users = 'UserList',
}

export enum QueryCacheKey {
  AlternativeSizes = 'AlternativeSizes',
  CustomerContext = 'CustomerContext',
  Customers = 'Customers',
  Invoice = 'Invoice',
  InvoiceDocuments = 'InvoiceDocuments',
  Invoices = 'Invoices',
  OrderDetails = 'OrderDetails',
  OrderLogs = 'OrderLogs',
  OrderProducts = 'OrderProducts',
  Orders = 'Orders',
  PaymentDetails = 'PaymentDetails',
  Product = 'Product',
  ProductDocuments = 'ProductDocuments',
  Products = 'Products',
  QuoteDetails = 'QuoteDetails',
  QuoteProducts = 'QuoteProducts',
  Quotes = 'Quotes',
  SalesGroup = 'SalesGroup',
  SalesGroups = 'SalesGroups',
  Search = 'Search',
  User = 'User',
  UserDocuments = 'UserDocuments',
  Users = 'Users',
}

export const DefaultLocale = SupportedLocaleCode.enAU
export const DefaultLanguage = SupportedLanguage.English
export const DefaultCountry = SupportedCountry.Australia
